import request from '@/utils/request2'

// 列表(主数据列表)
export function loadStoreVisitCheckInListDataApi(data) {
  return request({
    url: 'tms-web/storeVisitCheckIn/listByPage',
    method: 'post',
    data
  })
}

// 导出
export function exportStoreVisitCheckInListDataApi(data) {
  return request({
    url: 'tms-web/storeVisitCheckIn/exportByPage',
    method: 'post',
    data
  })
}

// 导出ZIP
export function exportStoreVisitCheckInImgZipApi(data) {
  return request({
    url: 'tms-web/storeVisitCheckIn/exportByImgZip',
    method: 'post',
    data
  })
}

// 忽略
export function ignoreStoreVisitCheckInApi(data) {
  return request({
    url: 'tms-web/storeVisitCheckIn/ignore',
    method: 'post',
    data
  })
}

// 作废
export function deleteStoreVisitCheckInApi(data) {
  return request({
    url: 'tms-web/storeVisitCheckIn/delete',
    method: 'post',
    data
  })
}

// 查看
export function viewStoreVisitCheckInApi(data) {
  return request({
    url: 'tms-web/storeVisitCheckIn/view',
    method: 'post',
    data
  })
}
